import React  from 'react';
import Iframe from 'react-iframe'
import './App.css';
import './Notebook.css';
import NotebookLang from './NotebookLang.json';

class NotebookChat extends React.Component {

	renderIFrame() {
		
		var userID = this.props.userID;
		var notebookID = this.props.notebookID;
		var language = this.props.language;
		var userID2 = 2*userID + 123;
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/chat/index.html?obf=" + userID2;
		url = url + "&notebookid=" + notebookID;
		url = url + "&language=" + language;
		
		return (
			<div className="NotebookChatAIContainer">
				<Iframe url={url} width="99%" height="100%" frameBorder="0" allow="clipboard-write"></Iframe>
			</div>
		);
	}

	render() {

		var notebookJsonObj = this.props.notebookJsonObj;
		var titleString = this.props.getLang(NotebookLang, "chat");
		var notebookTitle = "";
		
		if (notebookJsonObj !== null) {
			notebookTitle = notebookJsonObj.title;
			/*if (notebookTitle.length > 43) {
				notebookTitle = notebookTitle.substring(0,40) + "...";
			}*/
			titleString = this.props.getLang(NotebookLang, "chat")  + " - " + notebookTitle;
		}
		
		return (
			<div className="NotebookChatTopContainer">
				<div style={{height: "12px"}}></div>
				<div className="NotebookChatTitle">{titleString}</div>
				<hr className="NotebookCustomLine" />
				{this.renderIFrame()}
				<div style={{height: "12px"}}></div>
			</div>
		);
	}
}

export default NotebookChat;

